import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { moduleName } from '../constants';
import type { PermissionManagerSlice } from '../types';

const initialState: PermissionManagerSlice = {
  timeStamp: '',
};

export const permissionManagerSlice = createSlice({
  name: moduleName,
  initialState: initialState,
  reducers: {
    setPermsManagerTimeStamp: (
      state,
      action: PayloadAction<{
        timeStamp: string;
      }>,
    ) => {
      const { timeStamp } = action.payload;
      state.timeStamp = timeStamp;
    },
  },
});

const { actions, reducer } = permissionManagerSlice;

export { reducer };

export const { setPermsManagerTimeStamp } = actions;
